module.exports = __webpack_public_path__ + "img/re+rec.2c864b8a.jpg";